export default "__VITE_PUBLIC_ASSET__5d3e9c9e__"